/*
 * This file is part of huoxin/filter-rule-manager.
 *
 * Copyright (c) 2026 huoxin.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Component from 'flarum/common/Component';
import Icon from 'flarum/common/components/Icon';
export default class BuiltinTemplate extends Component {
  view(vnode) {
    const _this$attrs = this.attrs,
      alert = _this$attrs.alert,
      variant = _this$attrs.variant;
    const settings = alert.displaySettings || {};
    let iconName = settings.icon;
    if (!iconName) {
      iconName = alert.type === 'block' ? 'fas fa-times-circle' : alert.type === 'warning' ? 'fas fa-exclamation-triangle' : 'fas fa-info-circle';
    }

    // Use React.CSSProperties-like typing or just any for React/Mithril inline styles
    const style = {};
    if (settings.textColor) style.color = settings.textColor;
    if (settings.backgroundColor) style.backgroundColor = settings.backgroundColor;
    const iconStyle = {};
    if (settings.iconColor) iconStyle.color = settings.iconColor;
    return m("div", {
      className: "FilterRuleManager-item FilterRuleManager-item--".concat(variant, " FilterRuleManager-item--").concat(alert.type),
      style: style
    }, iconName !== 'none' && m("span", {
      className: "FilterRuleManager-item-icon",
      style: iconStyle
    }, m(Icon, {
      name: iconName
    })), m("div", {
      className: "FilterRuleManager-item-content"
    }, settings.title && m("strong", {
      className: "FilterRuleManager-item-title"
    }, m.trust(settings.title)), m("span", {
      className: "FilterRuleManager-item-message"
    }, m.trust(alert.message))));
  }
}
flarum.reg.add('huoxin-filter-rule-manager', 'common/components/BuiltinTemplate', BuiltinTemplate);